import React from "react";
import InterviewCard from "../dashboard/interviewCard";
import InterviewList from "./InterviewList";

export default function Interview(props){
    const dummyInterviews = [
        {
          _id: 1,
          technology: "React",
          levelOfInterview: "Intermediate",
          createdAt: "2023-02-10T12:30:00Z",
          noOfQuestions: 10,
          isInterviewCompleted: true,
          isResultPublished: true,
          result: [
            { score: 80 }, // Overall score
            { score: 85 }, // Technical Skills
            { score: 75 }  // Communication
          ]
        },
        {
          _id: 2,
          technology: "Node.js",
          levelOfInterview: "Advanced",
          createdAt: "2023-02-05T14:45:00Z",
          noOfQuestions: 15,
          isInterviewCompleted: true,
          isResultPublished: true,
          result: [
            { score: 90 },
            { score: 95 },
            { score: 85 }
          ]
        },
        {
            _id: 3,
            technology: "React",
            levelOfInterview: "Intermediate",
            createdAt: "2023-02-10T12:30:00Z",
            noOfQuestions: 10,
            isInterviewCompleted: true,
            isResultPublished: true,
            result: [
              { score: 80 }, // Overall score
              { score: 85 }, // Technical Skills
              { score: 75 }  // Communication
            ]
          },
          {
            _id: 4,
            technology: "Node.js",
            levelOfInterview: "Advanced",
            createdAt: "2023-02-05T14:45:00Z",
            noOfQuestions: 15,
            isInterviewCompleted: true,
            isResultPublished: true,
            result: [
              { score: 90 },
              { score: 95 },
              { score: 85 }
            ]
          },
        {
            _id: 5,
            technology: "Node.js",
            levelOfInterview: "Advanced",
            createdAt: "2023-02-05T14:45:00Z",
            noOfQuestions: 15,
            isInterviewCompleted: false,
            isResultPublished: false,
            
          },
        
      ];
    return(
        <>
           <div>
           <h1 className="text-primary font-bold px-5 md:px-14 py-4 text-xl"> Skills based On recent interviews</h1>
           <InterviewCard completed={props.interview.length} tech={props.data.tech} communication={props.data.communication} score={props.data.overallRating} />
           </div>
            <div>
                <h1 className="px-5 md:px-14 font-bold text-xl text-primary -mb-6">Past Interviews</h1>
                <InterviewList interviews={props.interview} from="mobile" filterTopic={""} />
            </div>
        </>
    );
}